import { useDispatch, useSelector } from "react-redux";
import { submitCheckoutTotem } from "../../ducks/checkoutSlice";
import { resetSelfcheckoutSession } from "../../ducks/selfcheckoutSession";
import useGoTo from "../../hooks/useGoTo";
import useSubmitSelfcheckout from "../../hooks/useSubmitSelfcheckout";
import QuestionCheckout from "../QuestionCheckout";

// Totem: com maquininha TEF o pagamento acontece na própria tela
// (PaymentTEFScreen, que limpa a sessão no fim); sem ela, vai direto ao status.
export default function SelfCheckoutTotem() {
  const goTo = useGoTo();
  const dispatch = useDispatch();
  const shop = useSelector((state) => state.shop);

  const selfcheckoutConfig = shop.selfcheckoutConfigs[0] ?? {};

  const submit = useSubmitSelfcheckout(async () => {
    const order = await dispatch(submitCheckoutTotem());
    if (shop.totemTefModel) {
      goTo(`/paymentTEF/${order.shortReference}`);
      return;
    }

    dispatch(resetSelfcheckoutSession());
    goTo(`/status/${order.shortReference}`);
  });

  return (
    <QuestionCheckout
      takingHome={selfcheckoutConfig.askForLocation}
      cpfQuestion={selfcheckoutConfig.askForCpf}
      personalData={selfcheckoutConfig.askForName}
      dispatchSubmitCheckout={submit}
    />
  );
}
